/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIBomTreeResult } from './APIBomTreeResult';
import {
    APIBomTreeResultFromJSON,
    APIBomTreeResultFromJSONTyped,
    APIBomTreeResultToJSON,
} from './APIBomTreeResult';

/**
 * 
 * @export
 * @interface APIBomTreeResponse
 */
export interface APIBomTreeResponse {
    /**
     * 
     * @type {number}
     * @memberof APIBomTreeResponse
     */
    total: number;
    /**
     * 
     * @type {Array<APIBomTreeResult>}
     * @memberof APIBomTreeResponse
     */
    results: Array<APIBomTreeResult>;
    /**
     * 
     * @type {string}
     * @memberof APIBomTreeResponse
     */
    message?: string;
}

/**
 * Check if a given object implements the APIBomTreeResponse interface.
 */
export function instanceOfAPIBomTreeResponse(value: object): value is APIBomTreeResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIBomTreeResponseFromJSON(json: any): APIBomTreeResponse {
    return APIBomTreeResponseFromJSONTyped(json, false);
}

export function APIBomTreeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIBomTreeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(APIBomTreeResultFromJSON)),
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function APIBomTreeResponseToJSON(value?: APIBomTreeResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'results': ((value['results'] as Array<any>).map(APIBomTreeResultToJSON)),
        'message': value['message'],
    };
}

